import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined'
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined'
import { Language, Notification } from '@vae/server/dist/client'
import { ModalOption } from '@vae/server/src/types/notifications'
import dayjs from 'dayjs'
import React, { useContext, useMemo } from 'react'
import { useHistory } from 'react-router'
import { logEvent } from '../../../analytics/utils/firebaseUtils'
import { ModalContext } from '../../../contexts/ModalContext'

interface Props {
	notifications: Notification[]
	isNewNotifications: boolean
	language: Language
}

interface NotificationItemProps {
	notification: Notification
	isNewNotifications: boolean
	language: Language
}

const NotificationItem = ({
	notification,
	isNewNotifications,
	language,
}: NotificationItemProps) => {
	const { insertModal } = useContext(ModalContext)
	const history = useHistory()

	const IconComponent = isNewNotifications ? NotificationsActiveOutlinedIcon : CheckBoxOutlinedIcon
	const header = language === 'fi' ? notification.headerFi : notification.headerEn
	const content = language === 'fi' ? notification.contentFi : notification.contentEn
	const formattedDate = dayjs(notification.time).format('DD.MM HH.mm')

	const linkTarget = notification.linkTarget
	const modalLinkTarget = notification.modalLinkTarget
	const modalVariable = notification.modalVariable

	const handleClick = () => {
		logEvent('click-open-notification', notification)

		if (linkTarget && linkTarget !== 'overview') {
			history.push(linkTarget)
		} else if (modalLinkTarget) {
			if (modalVariable && modalLinkTarget === 'electricCarDetail') {
				history.push(`/devices/electric-car/${modalVariable}`)
			} else {
				insertModal(modalLinkTarget as ModalOption)
			}
		}
	}

	return (
		<div onClick={handleClick}>
			<div className='noti-header'>
				<div className='noti-icon rounded-full'>
					<IconComponent
						className={'icon text-brand-primary-100-light dark:text-brand-primary-100-dark'}
					/>
				</div>
				<span className='text-text-dark dark:text-white'>{header}</span>
				<p className='noti-date text-text-dark dark:text-white'>{formattedDate}</p>
			</div>
			<p className='noti-content text-text-grey-200 dark:text-text-grey-100'>{content}</p>
		</div>
	)
}

const DisplayNotifications = ({ notifications, isNewNotifications, language }: Props) => {
	const filteredNotifications = useMemo(() => {
		return notifications
			.filter(notification => notification.isRead !== isNewNotifications)
			.sort((a, b) => dayjs(b.time).diff(dayjs(a.time)))
	}, [notifications, isNewNotifications])

	return (
		<div className='flex flex-col gap-2'>
			{filteredNotifications.map((notification, index) => (
				<NotificationItem
					key={index}
					notification={notification}
					isNewNotifications={isNewNotifications}
					language={language}
				/>
			))}
		</div>
	)
}

export default DisplayNotifications
